import { AlertTakeoverCampaign } from 'modules/campaigns/lib/takeovers/AlertTakeover/types';
import { FC } from 'react';
import { AlertOverrides } from './AlertOverrides';
import { AlertOverridesFormProvider } from './context/AlertOverridesFormProvider';
import { AlertOverridesProvider } from './context/AlertOverridesProvider';

type AlertTakeoverProps = {
  campaignData: AlertTakeoverCampaign;
  onTakeoverOpen: (isOpen: boolean) => void;
};

export const AlertTakeover: FC<AlertTakeoverProps> = ({ campaignData, onTakeoverOpen }) => {
  return (
    <AlertOverridesProvider campaignData={campaignData}>
      <AlertOverridesFormProvider>
        <AlertOverrides campaignData={campaignData} onTakeoverOpen={onTakeoverOpen} />
      </AlertOverridesFormProvider>
    </AlertOverridesProvider>
  );
};
